import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24.8 24.352"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { transform: "translate(-5.4 -7.59)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.4,30.171A1.771,1.771,0,0,1,7.171,28.4H28.429a1.771,1.771,0,1,1,0,3.543H7.171A1.771,1.771,0,0,1,5.4,30.171Zm5.833-13.653a1.771,1.771,0,0,1,2.5,0l2.291,2.291.131-9.448a1.771,1.771,0,1,1,3.543,0l-.131,9.448,2.29-2.29a1.771,1.771,0,1,1,2.5,2.5l-5.315,5.314a1.771,1.771,0,0,1-2.5,0l-5.314-5.314a1.771,1.771,0,0,1,0-2.5Z",
    fill: "#fff",
    "fill-rule": "evenodd"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}